/**
 * @generated SignedSource<<fb936682851edd1b671772f2a4ee36d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type actionButtonsTracking_item$data = {
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly contemporaryTrackingString: string;
  readonly pricing: {
    readonly totalAmount: {
      readonly convertedAmounts: {
        readonly AUD: number | null;
        readonly CAD: number | null;
        readonly CHF: number | null;
        readonly DKK: number | null;
        readonly EUR: number | null;
        readonly GBP: number | null;
        readonly MXN: number | null;
        readonly NOK: number | null;
        readonly SEK: number | null;
        readonly USD: number | null;
      } | null;
    } | null;
  } | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "actionButtonsTracking_item";
};
export type actionButtonsTracking_item$key = {
  readonly " $data"?: actionButtonsTracking_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"actionButtonsTracking_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "actionButtonsTracking_item"
};

(node as any).hash = "f2ea6f0ffe24610c2567049c475f6eac";

export default node;
